import { Controller } from "stimulus";

class PLPBannerController extends Controller {
  static targets = ["caret", "description"];

  connect() {
    this.checkOverflow();
  }

  checkOverflow() {
    const description = this.descriptionTarget;
    const isOverflowing = description.scrollHeight > description.clientHeight;
    this.caretTarget.classList.toggle("tw-opacity-0", !isOverflowing);
    this.caretTarget.classList.toggle("tw-pointer-events-none", !isOverflowing);
  }

  toggleShowMore() {
    this.caretTarget.classList.toggle("tw-rotate-180");
    this.descriptionTarget.classList.toggle("tw-h-20");
  }
}

Stimulus.register("plp-banner", PLPBannerController);
